import React, { useState, useEffect, useRef } from 'react';
import { GENERAL_KEBAB_TOOLTIP } from '../../constants';
import {
  TeamActionBtn,
  AgentRowMenuWrap,
  AgentRowMenuPopover,
  AgentRowMenuItem,
} from './styled';
import Icon from '../icon';

const AgentRowMenu = ({ disabled, items }) => {
  const [open, setOpen] = useState(false);
  const wrapRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const onDocClick = e => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', onDocClick);
    return () => document.removeEventListener('mousedown', onDocClick);
  }, [open]);

  return (
    <AgentRowMenuWrap ref={wrapRef}>
      <TeamActionBtn
        onClick={() => setOpen(o => !o)}
        disabled={disabled}
        title={disabled ? GENERAL_KEBAB_TOOLTIP : 'More actions'}
      >
        <Icon name="more" size={14} />
      </TeamActionBtn>
      {open && !disabled && (
        <AgentRowMenuPopover>
          {items.map(item => (
            <AgentRowMenuItem
              key={item.label}
              onClick={() => {
                setOpen(false);
                item.onClick();
              }}
            >
              {item.label}
            </AgentRowMenuItem>
          ))}
        </AgentRowMenuPopover>
      )}
    </AgentRowMenuWrap>
  );
};

export default AgentRowMenu;
